import { createSelector } from 'reselect';
import { IMainState, RootState } from '../../../models/store/store-models';

export const selectCoreSlice = (state: RootState): IMainState => state.main;

export const selectPreferencesProfile = createSelector(
  selectCoreSlice,
  (state: IMainState) => state.preferencesProfile,
);
